/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IComboBoxStyles } from "office-ui-fabric-react/lib/ComboBox";
import { IIconStyles } from "office-ui-fabric-react/lib/Icon";

/**
 * Styling for comboBox.
 * @type {Partial<IComboBoxStyles>}
 */
export const comboBoxStyles: Partial<IComboBoxStyles> = {
  container: { width: "100%" },
};

/**
 * Styling for Icon control.
 * @type {Partial<IIconStyles>}
 * @param {boolean} hasAsterisk The value to determine if control label has required asterisk.
 */
export const getIconStyles: (hasAsterisk: boolean) => Partial<IIconStyles> = (hasAsterisk) => {
  return { root: { paddingLeft: !hasAsterisk ? "10px" : "", cursor: "default" } };
};
